import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import StaticPostLayout from '../components/StaticPostLayout';
import InfoSection from '../components/TripInfo/how-to-plan-sustainable-hiking-trip';

class HowToPlanSustainableHikingTrip extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>How to Plan a Sustainable Hiking Trip (Complete Guide)</title>
          <meta name="description" content="Learn how to plan a sustainable hiking trip with simple eco-friendly tips. Reduce your impact, protect nature, and enjoy responsible outdoor adventures." />
          <meta property="og:title" content="How to Plan a Sustainable Hiking Trip (Complete Guide)" />
          <meta property="og:description" content="Learn how to plan a sustainable hiking trip with simple eco-friendly tips. Reduce your impact, protect nature, and enjoy responsible outdoor adventures." />
          <meta property="og:url" content="https://exploroff.com/hiking-guides/how-to-plan-sustainable-hiking-trip" />
          <meta property="og:type" content="article" />
          <meta property="og:image" content="https://exploroff.com/img/how-to-plan-a-sustainable-hiking-trip/sustainable-hiking-trip.webp" />
          <link rel="canonical" href="https://exploroff.com/hiking-guides/how-to-plan-sustainable-hiking-trip" />
          <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org", "@type": "BlogPosting",
            headline: "How to Plan a Sustainable Hiking Trip",
            description: "Learn how to plan a sustainable hiking trip with simple eco-friendly tips. Reduce your impact, protect nature, and enjoy responsible outdoor adventures.",
            image: ["https://exploroff.com/img/how-to-plan-a-sustainable-hiking-trip/sustainable-hiking-trip.webp"],
            author: { "@type": "Organization", name: "ExplorOFF" },
            publisher: { "@type": "Organization", name: "ExplorOFF", logo: { "@type": "ImageObject", url: "https://exploroff.com/img/favicon.png" } },
            mainEntityOfPage: { "@type": "WebPage", "@id": "https://exploroff.com/hiking-guides/how-to-plan-sustainable-hiking-trip" }
          })}</script>
        </Helmet>
        <MessengerCustomerChat pageId="101590111335192" appId="695593052231950" />
        <StaticPostLayout
          title="How to Plan a Sustainable Hiking Trip"
          category="hiking-guides"
          slug="how-to-plan-sustainable-hiking-trip"
          excerpt="Reduce your trail impact, protect the places you love, and enjoy responsible outdoor adventures."
          tags={['sustainability', 'planning']}
          readTime={7}
        >
          <InfoSection />
        </StaticPostLayout>
      </>
    );
  }
}

export default HowToPlanSustainableHikingTrip;
